import type { ChangeEvent } from "react";
import { useCallback } from "react";

import type { TextFieldProps } from "@mui/material/TextField";
import TextField from "@mui/material/TextField";

import type { MetricInputProps } from "./DataEntryInput.types";
import { InputMode } from "./DataEntryInput.types";
import { loadingInputSx } from "./loadingInputSx";
import { useInputSx } from "./useInputSx";

export type StringInputProps = MetricInputProps & {
  isLoading: boolean;
};

export const StringInput = ({ id, onChange, value, isDirty, mode, isLoading }: StringInputProps) => {
  const inputDisabled = mode === InputMode.ReadOnly || mode === InputMode.SiteEdit || isLoading;
  const inputReadOnly = inputDisabled || mode === InputMode.Loading;
  const inputSx = useInputSx({ mode, isDirty });

  const handleChange: TextFieldProps["onChange"] = useCallback(
    (evt: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => onChange(evt.target.value),
    [onChange],
  );

  return (
    <TextField
      data-component="MetricInput"
      data-id={id}
      id={`stringInput-${id}`}
      multiline
      fullWidth
      onChange={handleChange}
      value={value ?? ""}
      sx={isLoading ? loadingInputSx : undefined}
      disabled={inputDisabled}
      slotProps={{
        input: {
          readOnly: inputReadOnly,
          sx: inputSx,
        },
        htmlInput: { "data-component": "StringInput" },
      }}
    />
  );
};
